import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import type { RawAnomalyDto } from '../models/anomaly.types'

import { appHttp, unwrapEnvelope } from '@/shared/http'

function requestConfig(signal?: AbortSignal): AxiosRequestConfig {
  const config: AxiosRequestConfig = {
    suppressGlobalErrorHandler: true,
    meta: { suppressGlobalErrorHandler: true },
  }
  if (signal) config.signal = signal
  return config
}

/** The anomaly slice's only HTTP boundary (contract 28 §6). */
export class AnomalyApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async list(workspaceId: number, signal?: AbortSignal): Promise<RawAnomalyDto[]> {
    const response = await this.http.get(
      `/anomalies/workspace/${workspaceId}/`,
      requestConfig(signal),
    )
    return unwrapEnvelope<RawAnomalyDto[]>(response)
  }

  /** A failed workspace contributes no rows; successful workspace reads still render. */
  async listMany(workspaceIds: readonly number[], signal?: AbortSignal): Promise<RawAnomalyDto[]> {
    const settled = await Promise.allSettled(
      workspaceIds.map((workspaceId) => this.list(workspaceId, signal)),
    )
    return settled.flatMap((result) => (result.status === 'fulfilled' ? result.value : []))
  }
}

export const anomalyApi = new AnomalyApi()
